(function () {
  var defaults = {
    baseUrl: 'https://onj3z5ce49.execute-api.us-east-1.amazonaws.com/api',
    favoritesGetEndpoint: '/favorites/get',
    favoritesEndpoint: '',
    shopifyProductsEndpoint: '/products.json?limit=250',
    shopifyProductEndpoint: '',
    shopifySearchEndpoint: '/search/suggest.json',
  };

  var config = Object.assign({}, defaults, window.GroupHiitApiConfig || {});
  var shopifyProductCache = {};
  var shopifyCatalogPromise = null;

  if (!config.favoritesEndpoint) {
    config.favoritesEndpoint = String(config.favoritesGetEndpoint || defaults.favoritesGetEndpoint).replace(/\/get\/?$/, '');
  }

  function buildUrl(endpoint) {
    if (/^https?:\/\//i.test(endpoint)) {
      return endpoint;
    }

    return String(config.baseUrl).replace(/\/$/, '') + '/' + String(endpoint).replace(/^\//, '');
  }

  function normalizeShopifyId(id) {
    var match = String(id || '').match(/(\d+)(?:\D*)$/);
    return match ? match[1] : '';
  }

  function getProductsArray(payload) {
    if (!payload) return [];
    if (Array.isArray(payload.products)) return payload.products;
    if (payload.product) return [payload.product];
    if (payload.resources && payload.resources.results && Array.isArray(payload.resources.results.products)) {
      return payload.resources.results.products;
    }
    if (Array.isArray(payload)) return payload;
    return [];
  }

  function compactUnique(values) {
    var seen = {};
    var results = [];

    values.forEach(function (value) {
      var normalized = String(value || '').trim();
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      results.push(normalized);
    });

    return results;
  }

  function buildStorefrontUrl(endpoint) {
    if (/^https?:\/\//i.test(endpoint)) {
      return new URL(endpoint);
    }

    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return new URL(String(root).replace(/\/?$/, '/') + String(endpoint || '').replace(/^\//, ''), window.location.origin);
  }

  function buildShopifyUrl(endpoint, productId, page) {
    var url = buildStorefrontUrl(endpoint || config.shopifyProductsEndpoint);
    var normalizedId = normalizeShopifyId(productId);

    url.pathname = url.pathname
      .replace('{productId}', normalizedId)
      .replace('{id}', normalizedId);

    if (page) {
      url.searchParams.set('page', String(page));
    }

    if (!url.searchParams.has('limit') && !config.shopifyProductEndpoint) {
      url.searchParams.set('limit', '250');
    }

    return url.toString();
  }

  function buildShopifyBatchUrl(endpoint, productIds) {
    var url = buildStorefrontUrl(endpoint || config.shopifyProductsEndpoint);
    var ids = compactUnique(productIds || []).map(normalizeShopifyId).filter(Boolean);

    url.pathname = url.pathname
      .replace('{productIds}', ids.join(','))
      .replace('{ids}', ids.join(','));

    if (ids.length && url.pathname.indexOf(ids.join(',')) === -1 && !url.searchParams.has('ids')) {
      url.searchParams.set('ids', ids.join(','));
    }

    return url.toString();
  }

  async function requestShopifyJson(endpoint, productId, page, signal) {
    var response = await fetch(buildShopifyUrl(endpoint, productId, page), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      signal: signal,
    });

    if (!response.ok) {
      throw new Error('Shopify product request failed.');
    }

    return response.json();
  }

  async function requestShopifyBatchJson(endpoint, productIds, signal) {
    var response = await fetch(buildShopifyBatchUrl(endpoint, productIds), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      signal: signal,
    });

    if (!response.ok) {
      throw new Error('Shopify product request failed.');
    }

    return response.json();
  }

  async function requestShopifySearch(query, signal) {
    var url = buildStorefrontUrl(config.shopifySearchEndpoint);

    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[limit_scope]', 'all');
    url.searchParams.set('resources[options][unavailable_products]', 'hide');
    url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');

    var response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      signal: signal,
    });

    if (!response.ok) {
      throw new Error('Shopify search request failed.');
    }

    return response.json();
  }

  function cacheShopifyProducts(products) {
    products.forEach(function (product) {
      var productId = normalizeShopifyId(product && product.id);
      if (productId) {
        shopifyProductCache[productId] = product;
      }
    });
  }

  async function loadShopifyCatalog(signal) {
    if (shopifyCatalogPromise) return shopifyCatalogPromise;

    shopifyCatalogPromise = (async function () {
      var page = 1;
      var allProducts = [];

      while (page <= 10) {
        var payload = await requestShopifyJson(config.shopifyProductsEndpoint, null, page, signal);
        var products = getProductsArray(payload);

        cacheShopifyProducts(products);
        allProducts = allProducts.concat(products);

        if (products.length < 250) break;
        page += 1;
      }

      return allProducts;
    })();

    return shopifyCatalogPromise;
  }

  function getCachedProductsMap(productIds) {
    var productsById = {};

    productIds.forEach(function (productId) {
      var normalizedId = normalizeShopifyId(productId);
      if (normalizedId && shopifyProductCache[normalizedId]) {
        productsById[normalizedId] = shopifyProductCache[normalizedId];
      }
    });

    return productsById;
  }

  async function searchShopifyProducts(productIds, searchTerms, signal) {
    var queryParts = compactUnique((searchTerms || []).concat(productIds || []));
    if (!queryParts.length) return {};

    try {
      var payload = await requestShopifySearch(queryParts.join(' '), signal);
      cacheShopifyProducts(getProductsArray(payload));
    } catch (error) {
      console.error('Unable to search Shopify products for favorites:', error);
    }

    return getCachedProductsMap(productIds);
  }

  async function getShopifyProducts(productIds, params) {
    productIds = compactUnique(productIds || []).map(normalizeShopifyId).filter(Boolean);
    params = params || {};

    if (!productIds.length) return {};

    var productsById = getCachedProductsMap(productIds);
    var missingIds = productIds.filter(function (productId) {
      return !productsById[productId];
    });

    if (missingIds.length) {
      productsById = Object.assign(productsById, await searchShopifyProducts(missingIds, params.searchTerms || [], params.signal));
      missingIds = productIds.filter(function (productId) {
        return !productsById[productId];
      });
    }

    if (missingIds.length && config.shopifyProductEndpoint) {
      var productPayload = await requestShopifyBatchJson(config.shopifyProductEndpoint, missingIds, params.signal);
      cacheShopifyProducts(getProductsArray(productPayload));
      productsById = getCachedProductsMap(productIds);
      missingIds = productIds.filter(function (productId) {
        return !productsById[productId];
      });
    }

    if (missingIds.length) {
      await loadShopifyCatalog(params.signal);
      productsById = getCachedProductsMap(productIds);
    }

    return productsById;
  }

  async function requestJson(endpoint, options) {
    options = options || {};

    var response = await fetch(buildUrl(endpoint), {
      method: options.method || 'GET',
      headers: Object.assign({ Accept: 'application/json' }, options.headers || {}),
      body: options.body,
      signal: options.signal,
    });

    var text = await response.text();
    var payload = null;

    try {
      payload = text ? JSON.parse(text) : null;
    } catch (error) {
      payload = {
        message: text,
      };
    }

    if (!response.ok) {
      var message = payload && (payload.error || payload.message || payload.Message);
      throw new Error(message || 'API request failed.');
    }

    return payload;
  }

  function buildFavoritePayload(params, includeProductMetadata) {
    if (!params || !params.clerkUserId) {
      throw new Error('Missing Clerk user id.');
    }

    if (!params.productId) {
      throw new Error('Missing product id.');
    }

    var payload = {
      clerk_user_id: params.clerkUserId,
      product_id: String(params.productId),
    };

    if (includeProductMetadata) {
      if (params.productHandle) payload.product_handle = params.productHandle;
      if (params.productTitle) payload.product_title = params.productTitle;
    }

    return payload;
  }

  window.GroupHiitApi = {
    getFavorites: function (params) {
      if (!params || !params.clerkUserId) {
        return Promise.reject(new Error('Missing Clerk user id.'));
      }

      return requestJson(config.favoritesGetEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          clerk_user_id: params.clerkUserId,
        }),
        signal: params.signal,
      });
    },

    addFavorite: function (params) {
      return requestJson(config.favoritesEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildFavoritePayload(params, true)),
        signal: params ? params.signal : undefined,
      });
    },

    removeFavorite: function (params) {
      return requestJson(config.favoritesEndpoint, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(buildFavoritePayload(params, false)),
        signal: params ? params.signal : undefined,
      });
    },

    getShopifyProducts: getShopifyProducts,

    getShopifyProduct: async function (productId, params) {
      var normalizedId = normalizeShopifyId(productId);
      if (!normalizedId) return null;

      var productsById = await getShopifyProducts([normalizedId], params);
      return productsById[normalizedId] || null;
    },
  };
})();
